import { isNumber } from '@cutwise/utils';

import { FieldType } from '@/catalog/constants/fieldTypes';
import { Field } from '@/catalog/types/field';
import { ALL_CONTEXTS } from '@/common/constants/context';
import priceFormatter from '@/common/helpers/priceFormatter';

export const FIELD_PRICE: Field = {
  label: 'Price',
  fullLabel: 'Price',
  key: 'price',
  type: FieldType.Scalar,
  spGroupId: null,
  getValue(p) {
    return p.price ? p.price : null;
  },
  getText(p) {
    const value = this.getValue(p);

    return isNumber(value) ? priceFormatter.format(value) : null;
  },
  render(p) {
    return this.getText(p);
  },
  iteratee(p) {
    return p.price ? p.price * -1 : null;
  },
  contexts: ALL_CONTEXTS,
};
